"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Container = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  ${(0, _layout.setContainer)({
  size: 'sm'
})}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
exports.Container = Container;
const Text = _styledComponents.default.p`
  color: ${props => props.textColor || '#000000'};
  font-family: 'univers-black', sans-serif;
  margin-bottom: 30px;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${(0, _typography.setFontSizes)({
  xs: '20px',
  sm: '24px',
  lg: '24px'
})}
`;
exports.Text = Text;
const Button = _styledComponents.default.a`
  ${props => props.border && `
    border: 1px solid ${props.textColor || '#000000'};
  `};
  color: ${props => props.textColor || '#000000'};
  ${props => props.backgroundColor && `
    background-color: ${props.backgroundColor};
  `};
  ${props => props.backgroundColorHover && `
      &:hover {
        background-color: ${props.backgroundColorHover};
      }
  `};
  ${props => props.textColorHover && `
      &:hover {
        color: ${props.textColorHover};
      }
  `};
  height: 48px;
  padding: 0px 40px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  transition: 0.13s all;
  ${props => (0, _typography.setFont)({
  bold: props.bold
})};
  ${(0, _typography.setFontSizes)({
  xs: '13px',
  sm: '14px',
  lg: '14px'
})}
`;
exports.Button = Button;
//# sourceMappingURL=styles.js.map